export default __webpack_public_path__ + "static/media/phone-alt.5769c80a.svg";